import styled from "styled-components";
import { ERROR_TEXT_COLOR } from "../utils";

export const ErrorText = styled.div`
    color: ${ERROR_TEXT_COLOR};
    font-weight: 300;
`;
